import { render, staticRenderFns } from "./OrderRejectedByResearcher.vue?vue&type=template&id=9f1a95ea"
import script from "./OrderRejectedByResearcher.vue?vue&type=script&lang=js"
export * from "./OrderRejectedByResearcher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports